import * as BABYLON from 'babylonjs';
import * as GUI from 'babylonjs-gui';
import { Client } from "colyseus.js";

import Game from './game';
import { createSkyBox } from "./utils";

import { TezosToolkit } from '@taquito/taquito';
import { BeaconWallet } from '@taquito/beacon-wallet';
import { getStyle, Style } from './styles';
import { getCurrentProfile, setupViewer, setupCreator, setupCreatorLoaded } from './profiles'

const TEZOS_RPC = "https://rpc1.fxhash.xyz";
const ROOM_NAME = "GenartShowRoom";
const ENDPOINT = "wss://fxintell.xyz:8443";
//const ENDPOINT = "ws://localhost:2567";
//const ENDPOINT = "ws://35.188.127.161:2567";
const Tezos = new TezosToolkit(TEZOS_RPC);

const authorized = [
    'tz1SuqfMFLZSFJTnmGrh6gxC7b2Z4zELVZtD',
    "tz1agchaEF9EK3ARhHDeKTQFBzw4CjNkHKEJ",
]
export default class Menu {
    private _canvas: HTMLCanvasElement;
    private _engine: BABYLON.Engine;
    private _scene: BABYLON.Scene;
    private _camera: BABYLON.ArcRotateCamera;
    private _advancedTexture: GUI.AdvancedDynamicTexture;

    private _colyseus: Client = new Client(ENDPOINT);
    private userAddress: string;
    private wallet: BeaconWallet;
    private style: Style = getStyle();

    private _errorMessage: GUI.TextBlock = new GUI.TextBlock("errorText");

    constructor(canvasElement: string) {
        // Create canvas and engine.
        this._canvas = document.getElementById(canvasElement) as HTMLCanvasElement;
        this._engine = new BABYLON.Engine(this._canvas, true);
    }

    async hasActiveAccount() {
        const account = await this.wallet.client.getActiveAccount();
        console.log('activeAccount', account);
        this.userAddress = account ? account.address : undefined;
        return account && account.address.length !== 0;
    }

    async isCreator() {
        return (await this.hasActiveAccount()) && authorized.includes(this.userAddress);
    }

    async initializeWallet() {
        const options = {
            name: 'genart World',
            iconUrl: 'https://tezostaquito.io/img/favicon.svg',
            preferredNetwork: 'mainnet',
        };
        this.wallet = new BeaconWallet(options as any);
        if (!(await this.hasActiveAccount())) {
            await this.wallet.requestPermissions({
                network: {
                    type: 'mainnet' as any,
                },
            });
        }
        this.userAddress = await this.wallet.getPKH();
        console.log('address', this.userAddress)
        Tezos.setWalletProvider(this.wallet);
    }

    createRoom(room, x, y): BABYLON.Mesh {
        const sphere = BABYLON.MeshBuilder.CreateSphere(`room-${room.id}`, {
            segments: 32,
            diameter: 80
        }, this._scene);

        // Set player mesh properties
        const sphereMaterial = new BABYLON.StandardMaterial(`playerMat-${room.id}`, this._scene);
        sphereMaterial.backFaceCulling = true;
        let hdrTexture = new BABYLON.HDRCubeTexture(`./public/textures/${this.style.reflection}.hdr`, this._scene, 512);
        hdrTexture.rotationY = this.style.menuRotation;
        sphereMaterial.reflectionTexture = hdrTexture;
        sphereMaterial.reflectionTexture.coordinatesMode = BABYLON.Texture.CUBIC_MODE;
        sphereMaterial.reflectionTexture.level = .5;
        sphereMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
        sphereMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
        sphereMaterial.emissiveColor = BABYLON.Color3.FromHexString("#444400");
        sphere.material = sphereMaterial;
        sphere.position.x = x;
        sphere.position.y = y;

        var plane = BABYLON.CreatePlane("plane", { width: 80, height: 80 });
        plane.parent = sphere;
        plane.position.y = -60;
        plane.rotation.y = Math.PI;

        var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(plane);

        var button1 = GUI.Button.CreateSimpleButton("but1", `${room.metadata.profile.title}\nClients: ${room.clients}`);
        button1.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        button1.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        button1.width = 80;
        button1.height = 80;
        button1.color = "white";
        button1.fontSize = 175;
        button1.background = "green";
        button1.onPointerUpObservable.add(async () => {
            await this.createGame("join", this.userAddress, room);
            setupViewer(this.userAddress)
        });
        advancedTexture.addControl(button1);
        
        return sphere;
    }

    async createMenu(): Promise<void> {

        try {
            await this.initializeWallet();
        } catch (e) {
            console.log('initialize wallet failed', e)
        }

        this._scene = new BABYLON.Scene(this._engine);
        const to = new BABYLON.Vector3(0, -300, -100);
        this._camera = new BABYLON.ArcRotateCamera("camera", Math.PI / 2, 1, 600, to, this._scene);
        //this._camera.useAutoRotationBehavior = true;
        this._camera.setTarget(BABYLON.Vector3.Zero());
        this._camera.angularSensibilityY = 3000;
        this._camera.angularSensibilityX = 3000;
        let canvas = document.getElementById('renderCanvas')
        this._camera.attachControl(canvas, true);

        const rooms = await this._colyseus.getAvailableRooms("GenartShowRoom");
        console.log('rooms', rooms)
        let x = 200;
        let y = 100;
        let i = 0;
        let maxx = 5;
        for (let room of rooms) {
            const rep = this.createRoom(room, x, y);
            x -= 100;
            i++;
            if (i % maxx === 0) {
                y -= 150;
                x = 225;
            }
        }

        this._advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
        createSkyBox(this._scene, this.style);

        const button = GUI.Button.CreateSimpleButton("unsync", this.userAddress.length > 0 ? "UNSYNC" : "SYNC");
        button.width = "100px";
        button.height = "50px";
        button.fontFamily = "Roboto";
        button.thickness = 0;
        button.color = "#f8f8f8";
        button.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        button.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        button.paddingTop = "10px";
        button.paddingRight = "10px";
        button.onPointerClickObservable.add(async () => {
            await this.wallet.clearActiveAccount();
            location.reload();
        });

        // Colyseus logo
        const controlBox = new GUI.Rectangle("controlBox");
        controlBox.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        controlBox.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        controlBox.height = "100%";
        controlBox.width = "40%";
        controlBox.thickness = 0;

        // Button positioning
        const stackPanel = new GUI.StackPanel();
        stackPanel.isVertical = true;
        stackPanel.height = "50%";
        stackPanel.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        stackPanel.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;

        const buttonload = document.getElementsByClassName('button-load')[0] as HTMLButtonElement;
        buttonload.onclick = async (e) => {
            const p = getCurrentProfile();
            if (p) {
                this.swapControls(false);
                await this.createGame("create", this.userAddress, p);
                setupCreatorLoaded(this.userAddress)
            }
        }

        const creator = await this.isCreator();
        if (creator) {
            setupCreator(this.userAddress)
        } else {
            setupViewer(this.userAddress)
        }

        controlBox.addControl(stackPanel);
        this._advancedTexture.addControl(controlBox);
        this._advancedTexture.addControl(button);

        this.initLoadingMessageBox();
        this.initErrorMessageBox();
        this.swapLoadingMessageBox(false);
        this.swapErrorMessageBox(false);

        this.doRender();
    }

    private swapControls(isEnabled: boolean) {
        for (let btn of this._advancedTexture.getControlsByType("Button")) {
            btn.isEnabled = isEnabled;
        }
    }

    private async createGame(method: string, address: string, roomOrProfile: any): Promise<void> {
        let game: Game;
        try {
            switch (method) {
                case "create":
                    this.swapLoadingMessageBox(true);
                    game = new Game(this._canvas, this._engine, await this._colyseus.create(ROOM_NAME, {address: this.userAddress, profile: roomOrProfile}));
                    break;
                case "join":
                    this.swapLoadingMessageBox(true);
                    game = new Game(this._canvas, this._engine, await this._colyseus.joinById(roomOrProfile.roomId, { address: this.userAddress }));
                    break;
                default:
                    this.swapLoadingMessageBox(true);
                    game = new Game(this._canvas, this._engine, await this._colyseus.joinOrCreate(ROOM_NAME, { address: this.userAddress }));
            }
            this._scene.dispose();
            await game.bootstrap();
        } catch (error) {
            this._errorMessage.text = error.message;
            this.swapErrorMessageBox(true);
        }
    }

    private doRender(): void {
        // Run the render loop.
        this._engine.runRenderLoop(() => {
            this._scene.render();
        });

        // The canvas/window resize event handler.
        window.addEventListener('resize', () => {
            this._engine.resize();
        });
    }

    private initLoadingMessageBox() {
        const loadingMessage = new GUI.Rectangle("messageBox");
        loadingMessage.thickness = 0;
        loadingMessage.background = "#131313";

        const loadingText = new GUI.TextBlock("loadingText");
        loadingText.text = "LOADING..."
        loadingText.fontFamily = "Roboto";
        loadingText.color = "#fad836";
        loadingText.fontSize = "30px";
        loadingMessage.addControl(loadingText);

        this._advancedTexture.addControl(loadingMessage);
    }

    private initErrorMessageBox() {
        const errorMessageBox = new GUI.Rectangle("errorMessageBox");
        errorMessageBox.thickness = 0;
        errorMessageBox.background = "#131313";

        this._errorMessage.fontFamily = "Roboto";
        this._errorMessage.color = "#ff1616";
        this._errorMessage.fontSize = "20px";
        this._errorMessage.textWrapping = true;
        errorMessageBox.addControl(this._errorMessage);

        const button = GUI.Button.CreateImageWithCenterTextButton("tryAgainButton", "<- TRY AGAIN", "./public/btn-default.png");
        button.width = "200px";
        button.height = "60px";
        button.fontFamily = "Roboto";
        button.thickness = 0;
        button.color = "#c0c0c0";
        button.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        button.paddingBottom = "20px";
        button.onPointerClickObservable.add(() => {
            this.swapControls(true);
            this.swapLoadingMessageBox(false);
            this.swapErrorMessageBox(false);
        });
        errorMessageBox.addControl(button);

        this._advancedTexture.addControl(errorMessageBox);
    }

    private swapLoadingMessageBox(isEnabled: boolean) {
        const messageBox = this._advancedTexture.getControlByName("messageBox");
        messageBox.isEnabled = isEnabled;
        messageBox.alpha = isEnabled ? 0.75 : 0;
    }

    private swapErrorMessageBox(isEnabled: boolean) {
        this.swapLoadingMessageBox(false);

        const messageBox = this._advancedTexture.getControlByName("errorMessageBox");
        this._advancedTexture.getControlByName("tryAgainButton").isEnabled = true;
        messageBox.isEnabled = isEnabled;
        messageBox.alpha = isEnabled ? 0.75 : 0;
    }
}
